module.exports = {
  ORG_TYPE_ENTERPRISE: 'ORG_TYPE_ENTERPRISE'
  ORG_TYPE_BUSINESS_CLASS: 'ORG_TYPE_BUSINESS_CLASS'
  ORG_TYPE_FREE: 'ORG_TYPE_FREE'
}
